export interface IBookingConfirmationEmail {
  id?: any;
  bankId?: any;
  email?: string | ' ';
  createdBy?: string;
  createdDate?: Date | null;
  lastModifiedBy?: string;
  lastModifiedDate?: Date | null;
}

export const defaultValue: Readonly<IBookingConfirmationEmail> = {
  id: '',
  bankId: '',
  email: '',
  createdBy: '',
  createdDate: null,
  lastModifiedBy: '',
  lastModifiedDate: null,
};
